import {CSSProperties, memo, useMemo} from "react";
import {CELL_SIZE, ClientDiagramNode} from "../../utility/types";
import {getIcon} from "../../icons";

export const NodeIcon = memo(({node}: {node: ClientDiagramNode}) => {
  const worldPos = node.position.mulScalar(CELL_SIZE).addScalar(0.5 * CELL_SIZE);

  const iconStyle = useMemo<CSSProperties>(
    () => ({
      position: "absolute",
      top: 0,
      left: 0,
      transform: `translate(${worldPos.x}px, ${worldPos.y}px) translate(-50%, -50%)`,
      width: `${CELL_SIZE}px`,
      height: `${CELL_SIZE}px`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    }),
    [worldPos.x, worldPos.y],
  );

  const imgStyle = useMemo<CSSProperties>(
    () => ({width: "100%", height: "100%", objectFit: "contain", userSelect: "none"}),
    [],
  );

  const icon = useMemo(() => getIcon(node.icon), [node.icon]);

  return (
    <div style={iconStyle}>
      <img src={icon.url} alt={node.label} style={imgStyle} draggable={false} />
    </div>
  );
});
